(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/minicart"],{

/***/ "./src/js/minicart.js"
/*!****************************!*\
  !*** ./src/js/minicart.js ***!
  \****************************/
() {

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
(function () {
  /**
   * Function debouncer
   */
  var debounce = function debounce(fn, delay) {
    var timeout;
    return function () {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        return fn.apply(_this, args);
      }, delay);
    };
  };

  // Query selectors
  var miniCart = document.querySelector('.js-minicart'); // Minicart
  var loader = miniCart === null || miniCart === void 0 ? void 0 : miniCart.querySelector('.js-minicart-loader'); // Loader    
  var indicator = document.querySelector('[data-minicart-indicator]'); // Total items quantity
  var freeShippingMessage = document.querySelector('[data-free-shipping-message]'); // Free shipping data
  var freeShippingIndicator = document.querySelector('.js-free-shipping-indicator'); // Free shipping data
  var totals = document.querySelector('.js-subtotal'); // Subtotal
  var discounts = document.querySelector('.js-discounts'); // Discounts
  var notice = document.querySelector('.minicart__notice'); // Notice

  /**
   * Loader functions
   */
  var showLoader = function showLoader() {
    return loader && (loader.style.display = 'block');
  };
  var hideLoader = function hideLoader() {
    return loader && (loader.style.display = 'none');
  };

  /**
   * Refresh the data in the mini cart
   */
  var refreshMiniCart = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var key,
        response,
        data,
        htmlString,
        parser,
        doc,
        newIndicator,
        newFreeShippingPercentage,
        newFreeShippingMessage,
        newTotals,
        newDiscounts,
        miniCartContent,
        newContent,
        _miniCartContent,
        _newContent,
        oldPercentage,
        newPercentage,
        _args = arguments,
        _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            key = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
            _context.p = 1;
            _context.n = 2;
            return fetch('/?sections=minicart');
          case 2:
            response = _context.v;
            _context.n = 3;
            return response.json();
          case 3:
            data = _context.v;
            // Pak de HTML uit de response (Shopify zet section handles als keys)
            htmlString = data['minicart']; // Parse het HTML string fragment
            parser = new DOMParser();
            doc = parser.parseFromString(htmlString, 'text/html'); // Selecteer de nieuwe elementen
            newIndicator = doc.querySelector('[data-minicart-indicator]');
            newFreeShippingPercentage = doc.querySelector('[data-free-shipping-percentage]');
            newFreeShippingMessage = doc.querySelector('[data-free-shipping-message]'); // Totals
            newTotals = doc.querySelector('[data-minicart-totals]');
            newDiscounts = doc.querySelector('[data-minicart-discounts]');
            if (key.length > 0) {
              // Vervang de bestaande inhoud
              miniCartContent = miniCart === null || miniCart === void 0 ? void 0 : miniCart.querySelector('[data-line-item-id="' + key + '"]');
              newContent = doc.querySelector('[data-line-item-id="' + key + '"]');
              if (newContent && miniCartContent) {
                miniCartContent.innerHTML = newContent.innerHTML;
              } else if (miniCartContent) {
                miniCartContent.remove();
              }
            } else {
              // Vervang de bestaande inhoud
              _miniCartContent = miniCart === null || miniCart === void 0 ? void 0 : miniCart.querySelector('[data-minicart-items]');
              _newContent = doc.querySelector('[data-minicart-items]');
              if (_newContent && _miniCartContent) {
                _miniCartContent.innerHTML = _newContent.innerHTML;
              }
            }

            // Update andere elementen indien nodig
            if (newIndicator) {
              document.querySelector('[data-minicart-indicator]').innerHTML = newIndicator.innerHTML;
            }
            if (discounts && newDiscounts) {
              discounts.innerHTML = newDiscounts.innerHTML;
            }
            if (totals && newTotals) {
              totals.innerHTML = newTotals.innerHTML;
            }
            if (newFreeShippingPercentage) {
              document.querySelector('[data-free-shipping-percentage]').style.width = newFreeShippingPercentage.style.width;
            }
            if (freeShippingMessage && newFreeShippingMessage) {
              freeShippingMessage.innerHTML = newFreeShippingMessage.innerHTML;
            }
            if (newFreeShippingPercentage && freeShippingIndicator) {
              oldPercentage = freeShippingIndicator.style.width;
              newPercentage = parseInt(newFreeShippingPercentage.innerHTML);
              if (newPercentage === 100) {
                if (!freeShippingIndicator.classList.contains('fulfilled')) {
                  freeShippingIndicator.classList.add('fulfilled');
                }
              } else {
                if (freeShippingIndicator.classList.contains('fulfilled')) {
                  freeShippingIndicator.classList.remove('fulfilled');
                }
              }
              freeShippingIndicator.style.width = newPercentage + "%";
            }
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error('Mini cart refresh failed:', _t);
          case 5:
            _context.p = 5;
            hideLoader();
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4, 5, 6]]);
    }));
    return function refreshMiniCart() {
      return _ref.apply(this, arguments);
    };
  }();

  /**
   * Add to cart function
   */
  var addToCart = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var items,
        response,
        errorData,
        _args2 = arguments,
        _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            items = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [];
            if (!(!Array.isArray(items) || items.length === 0)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            // Show the minicart & loading state
            showMinicart();
            showLoader();
            _context2.p = 2;
            _context2.n = 3;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: items
              })
            });
          case 3:
            response = _context2.v;
            if (!response.ok) {
              _context2.n = 5;
              break;
            }
            // Show success notification and refresh the cart
            showNotice('success', "Item toegevoegd aan cart...", 5500);
            _context2.n = 4;
            return refreshMiniCart();
          case 4:
            _context2.n = 8;
            break;
          case 5:
            _context2.n = 6;
            return response.json();
          case 6:
            errorData = _context2.v;
            showNotice('danger', errorData.description || errorData.message, 10000);
            _context2.n = 7;
            return refreshMiniCart();
          case 7:
            hideLoader();
          case 8:
            _context2.n = 10;
            break;
          case 9:
            _context2.p = 9;
            _t2 = _context2.v;
            hideLoader();
          case 10:
            return _context2.a(2);
        }
      }, _callee2, null, [[2, 9]]);
    }));
    return function addToCart() {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Show notice in cart
   */
  var noticeTimeout = null;
  var showNotice = function showNotice(alertType, message) {
    var _notice$classList;
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;
    if (noticeTimeout) clearTimeout(noticeTimeout);
    (_notice$classList = notice.classList).remove.apply(_notice$classList, _toConsumableArray(_toConsumableArray(notice.classList).filter(function (c) {
      return c.startsWith('alert-');
    })));
    notice.innerHTML = message;
    notice.style.display = 'block';
    notice.classList.add('alert-' + alertType);
    noticeTimeout = setTimeout(function () {
      notice.style.display = 'none';
      notice.classList.remove('alert-' + alertType);
    }, duration);
  };

  /**
   * Handle the click action
   */
  var handleClick = debounce(function (event) {
    var btn = event.target.closest('.js-add-to-cart');

    // Add to cart gedraging
    if (btn) {
      var _document$querySelect, _document$querySelect2;
      var productId = (_document$querySelect = document.querySelector('.js-variation-id')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value;
      var quantity = parseInt(((_document$querySelect2 = document.querySelector('.js-quantity')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.value) || 1, 10);
      var bundleToggles = document.querySelectorAll('.js-bundle-toggle:checked');
      if (!productId) {
        console.warn('Missing product ID');
        return;
      }
      var items = [{
        id: parseInt(productId, 10),
        quantity: quantity
      }];
      bundleToggles.forEach(function (bundleToggle) {
        var bundleVariantId = bundleToggle.dataset.bundleVariantId;
        if (bundleVariantId) {
          items.push({
            id: parseInt(bundleVariantId, 10),
            quantity: quantity
          });
        }
      });
      addToCart(items);
      return;
    }
  }, 500);
  document.addEventListener('click', handleClick);

  /**
   * Show the minicart
   */
  var showMinicart = function showMinicart() {
    document.documentElement.classList.add('show-minicart');
  };

  /**
   * Handle clicks on +/-/remove
   */
  document.addEventListener('click', /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
      var decreaseBtn, increaseBtn, removeBtn, wrapper, lineItemKey, display, currentQty;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            // Read buttons
            decreaseBtn = event.target.closest('.js-decrease-qty');
            increaseBtn = event.target.closest('.js-increase-qty');
            removeBtn = event.target.closest('.js-remove-item'); // Get what key we're working with
            wrapper = event.target.closest('[data-item-key]');
            if (wrapper) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            // Get the line and display
            lineItemKey = wrapper.getAttribute('data-item-key');
            display = wrapper.querySelector('.quantity-display');
            if (lineItemKey) {
              _context3.n = 2;
              break;
            }
            return _context3.a(2);
          case 2:
            currentQty = parseInt(display.textContent, 10);
            if (decreaseBtn && currentQty > 1) updateCartItemQty(lineItemKey, currentQty - 1); // Minnen
            if (increaseBtn) updateCartItemQty(lineItemKey, currentQty + 1); // Plussen
            if (removeBtn) updateCartItemQty(lineItemKey, 0); // Remove
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());

  /**
   * Update an item in the cart
   */
  function updateCartItemQty(_x2, _x3) {
    return _updateCartItemQty.apply(this, arguments);
  }
  function _updateCartItemQty() {
    _updateCartItemQty = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(key, quantity) {
      var itemRow, response, errorData;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            // Get the entire row and start loader
            itemRow = document.querySelector('[data-line-item-id="' + key + '"]');
            itemRow.classList.add('is-loading');

            // Send to change
            _context4.n = 1;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: key,
                quantity: quantity
              })
            });
          case 1:
            response = _context4.v;
            if (!response.ok) {
              _context4.n = 3;
              break;
            }
            // Show success notification and refresh the cart item row
            showNotice('success', "Aangepast in winkelwagen", 3000);
            _context4.n = 2;
            return refreshMiniCart(key);
          case 2:
            _context4.n = 6;
            break;
          case 3:
            _context4.n = 4;
            return response.json();
          case 4:
            errorData = _context4.v;
            _context4.n = 5;
            return refreshMiniCart(key);
          case 5:
            showNotice('danger', errorData.description || errorData.message, 3000);
          case 6:
            itemRow.classList.remove('is-loading');
          case 7:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return _updateCartItemQty.apply(this, arguments);
  }
})();

/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/js/minicart.js"));
/******/ }
]);